import { QualityHighIcon } from './QualityHighIcon';

/**
 * author: Google
 * id C07BA504-080D-4B47-AD4D-7F772E5C92F3
 * name quality-high
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/quality-high.svg
 * tags
 * - Video / Movie 
 */
export const HighQualityIcon = QualityHighIcon;
export default HighQualityIcon